import { CSSProperties } from 'react';

export const wrapperStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '10px 16px 10px 16px'
};

export const middleStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flexGrow: 1,
  maxInlineSize: '100%',
  minInlineSize: '0'
};

export const beforeStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const afterStyle: CSSProperties = {
  ...beforeStyle
};

export const headStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px'
};

export const titleStyle: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};
